<script>
import CalendarWidget from '@components/safehaven-calendar/calendar-widget.vue'
import { navComputed, navMethods } from '@state/helpers'
import layout from '@src/mixins/layout.vue'

export default {
  components: {
    CalendarWidget,
  },
  mixins: [layout],
  data() {
    return { close: false }
  },
  computed: {
    ...navComputed,
  },
  methods: {
    ...navMethods,
    drawerInput(value) {
      if (this.calendarDrawer !== value)
        this.setDrawer({
          value: value,

          drawer: false,
        })
    },
  },
}
</script>

<template>
  <v-navigation-drawer
    :class="$style.calendarDrawer"
    :value="calendarDrawer"
    clipped
    v-bind="$attrs"
    color
    overlay-color
    right
    :absolute="$vuetify.breakpoint.mdAndUp"
    :app="$vuetify.breakpoint.mobile"
    :style="{ top: $vuetify.application.top + 'px', zIndex: 4 }"
    @input="drawerInput"
  >
    <div :class="$style.calendarWidget">
      <CalendarWidget></CalendarWidget>
    </div>
  </v-navigation-drawer>
</template>

<style lang="scss" module>
@import '@design';

.calendarDrawer {
  position: fixed !important;
  height: 100vh !important;
  -webkit-box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2),
    0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2),
    0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);
}

.calendarDrawer ::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.calendarDrawer ::-webkit-scrollbar-track {
  background: #b1b1b163;
}

/* Handle */
.calendarDrawer ::-webkit-scrollbar-thumb {
  background: rgba(90, 90, 90, 0.336);
  border-radius: 20px;
}

/* Handle on hover */
.calendarDrawer ::-webkit-scrollbar-thumb:hover {
  background: rgba(85, 85, 85, 0.61);
}
</style>

<style scoped>
/* stylelint-disable */
/deep/ .v-navigation-drawer__border {
  display: none;
}
/* stylelint-enable */
</style>
